import React from 'react';
import { Link } from 'react-router-dom';

export default function AdminSidebar() {
  return (
    <aside style={{ width: 240, padding: 16, borderRight: '1px solid #eee' }}>
      <nav style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <Link to="/admin" style={{ color: '#000', textDecoration: 'none', fontWeight: '600' }}>Dashboard</Link>
        <Link to="/admin/candidates" style={{ color: '#000', textDecoration: 'none' }}>Manage Candidates</Link>
        <Link to="/admin/committees" style={{ color: '#000', textDecoration: 'none' }}>Manage Committees</Link>
        <Link to="/admin/voters" style={{ color: '#000', textDecoration: 'none' }}>Search Voters</Link>
        <Link to="/admin/solicitations" style={{ color: '#000', textDecoration: 'none' }}>Solicitations</Link>
  {/* Add other admin links here */}
      </nav>
    </aside>
  );
}
